import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import IconButton from '../../elements/IconButton'
import Dropdown from '../../elements/ReactSelectDropdown'
import TextInput from '../../elements/TextInput'
import Button from '../../elements/Button'

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { PDFDocument } from "pdf-lib";
import { StandardFonts, rgb } from "pdf-lib";

import Papa from 'papaparse';

const Main = (props) => {

    console.log(props)

    const [loadedData, setLoadedData] = useState([])

    const isCancelled = useRef(false);

    const convertPayeeToUser = (payee, user, spiffee, dealership) => {
        if (payee === null) {return 'No User'}
        if (payee === 0) {return spiffee.name}
        if (payee === 1) {return dealership.name}
        if (payee === 2) {return 'Subagents Under Dealer'}
        if (payee === 3) {return 'Inside Sales'}
    }

    const handleCancelFetch = () => {
        isCancelled.current = true;
    };

    function addCommas(number) {
        // Convert the number to a string and use a regular expression to add commas
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function transformInputDate(inputDate) {
        // Parse the input date string
        const date = new Date(inputDate);
      
        // Extract the year, month, and day from the input date
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth() + 1; // getUTCMonth() returns 0-11
        const day = date.getUTCDate();
      
        // Format the month and day to ensure they are in 'MM' or 'DD' format
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
      
        // Construct the new date string
        // If you intended to literally use '2123' as the year, replace 'year' with '2123' in the next line
        const newDateStr = `${year}-${formattedMonth}-${formattedDay}`;
      
        return newDateStr;
    }
      
    function formatNum(num) {
        return new Intl.NumberFormat('en-US').format(num);
    }

    const formatMoney = (value) => {
        const num = Number(value) || 0
        return (num < 0 ? '-$' : '$') + new Intl.NumberFormat('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Math.abs(num))
    }

    // A negative previous week carries into this week, and the sheet shows the math
    const weeklyNetText = (week) => {
        const carryover = Number(week?.carryover) || 0
        if (carryover < 0)
        {
            return formatMoney(carryover) + ' + ' + formatMoney(week?.weekly_net) + ' = ' + formatMoney(week?.adjusted_net)
        }
        return formatMoney(week?.adjusted_net)
    }
    
    const transposeArray = (array) => {
        return array[0].map((_, colIndex) => array.map(row => row[colIndex]));
    };

    const buildMonthlySheetPDF = (data, role) => {

        console.log(data)
        console.log(role)
        
        const isMgmt = role === 'management'
        const isAgent = role === 'subagent'

        // Sum contract_count for every week except the first
        const monthlyContractCount = data.weeks.slice(1).reduce((sum, week) => sum + (Number(week?.contract_count) || 0), 0)

        // Initialize the PDF in landscape mode
        const doc = new jsPDF({ orientation: 'landscape' });

        const addPageNumbers = (doc) => {
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height;
            const pageWidth = pageSize.width;

            // Add footer with page number
            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text(
                    `Page ${i}`,
                    pageWidth - 30,
                    pageHeight - 10
                );
            }
        };

        doc.text(`User: ${data.name} | ${data.month}`, 14, 10);

        let startY = 20;

        data.weeks.forEach((week, index) => {
            const adminString = Array.isArray(week?.contract_count_by_admin)
                ? week.contract_count_by_admin.map(admin => `${admin.code}-${admin.count.toFixed(2)}`).join(' , ')
                : ''

            let body = [
                [week.week_label,'','','Notes'],
                [!isAgent ? 'Weekly Total Agent Net: ' + formatMoney(week.weekly_total_agent_net):'Weekly Net: ' + weeklyNetText(week),'Paid','$' + formatNum(week.paid_amount), week.paid_amount_notes],
            ]

            if (!isMgmt)
            {
                body.push([adminString,'Bring Month To Paid','$' + formatNum(week.bmt_paid_amount), week.bmt_notes])
            }

            body.push([isMgmt ? adminString:'','Bonuses Paid', '$' + formatNum(week.bonuses_paid_amount), week.bonuses_paid_notes])

            if (isAgent && index === data.weeks.length - 1)
            {
                body.push(['Monthly Contract Count: ' + monthlyContractCount.toFixed(2),'','',''])
            }

            doc.autoTable({
                startY,
                head: [['Pay System: ' + week.payment_system, 'Reviewed: ' + week.reviewed, '', '']],
                body: body,
                styles: {
                    lineColor: [200, 200, 200],
                    lineWidth: 0.1
                },
                bodyStyles: {
                    fillColor: false
                },
                headStyles: {
                    fillColor: false,
                    textColor: 0,
                    lineColor: [200, 200, 200],
                    lineWidth: 0.1
                },
                tableLineColor: [200, 200, 200],
                tableLineWidth: 0.1,
                willDrawCell: function (data) {
                    data.cell.styles.fillColor = false;
                }
            });

            // Leave 10pt of space before the next table
            startY = doc.lastAutoTable.finalY + 10;
        });

        addPageNumbers(doc);

        return doc;
    }
    
    const downloadPDF = () => {

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json")
            
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({
                month: props.calStartDate.slice(0, 7),
            })
        }

        console.log(props.specificAgent)

        if (props.specificAgent.role === 'subagent' || props.specificAgent.role === 'management')
        {
            props.tokenSafeAPIRequest('/metrics/monthly_sheet/' + (props.specificAgent.role === 'subagent' ? 'agent':'mgmt') + '/' + props.specificAgent.id + '?fetch_links=true', requestOptions, '', (result, status) => {
                console.log(result)

                let data = result;

                const doc = buildMonthlySheetPDF(data, props.specificAgent.role)

                doc.save(`${data.name} | ${data.month} | Monthly Sheets`);
            })
        }
    }


    function formatToMDY(dateString) {
        const date = new Date(dateString);
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    }

    const [downloadState, setDownloadState] = useState(0)

    const downloadAllPDF = () => {
        const agents = props.agents;
        
        if (!agents || agents.length === 0) {
            console.log('No agents available');
            return;
        }

        console.log(agents)

        // Filter agents to only include subagent or mgmt roles  - Dave Mccready ID
        const filteredAgents = agents.filter(agent => (agent.value.role === 'subagent' || agent.value.role === 'management') && agent.value.id !== "659742d17c605a59716c4561" && agent.value.id !== "659742d67c605a59716c4585" && agent.value.id !== "659742e37c605a59716c45d7");

        if (filteredAgents.length === 0) {
            console.log('No valid agents with subagent or mgmt role');
            return;
        }

        setDownloadState('Generating PDFs...');

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        const delay = (ms, value) => new Promise(resolve => setTimeout(() => resolve(value), ms));

        const asyncMapWithPromises = (array, asyncCallback) => {
            return array.reduce((promiseChain, item) => {
                return promiseChain.then(results =>
                    asyncCallback(item).then(result => [...results, result])
                );
            }, Promise.resolve([]));
        };

        const fetchAgentMonthlyData = (agent) => {
            return new Promise((resolve, reject) => {
                const requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    redirect: 'follow',
                    body: JSON.stringify({
                        month: props.calStartDate.slice(0, 7),
                    })
                };

                props.tokenSafeAPIRequest(
                    '/metrics/monthly_sheet/' + (agent.value.role === 'subagent' ? 'agent' : 'mgmt') + '/' + agent.value.id + '?fetch_links=true',
                    requestOptions,
                    '',
                    (result, status) => {
                        if (status !== 200) {
                            reject(new Error('API request failed for agent: ' + agent.label + agent.value.role + agent.value.id));
                            return;
                        }
                        // Keep the role with the data so the PDF knows whether to show Bring Month To Paid
                        resolve({...result, role: agent.value.role});
                    }
                );
            });
        };

        asyncMapWithPromises(filteredAgents, agent => {
            return delay(100, fetchAgentMonthlyData(agent));
        }).then(agentDataArray => {
            setDownloadState('Merging PDFs...');

            asyncMapWithPromises(agentDataArray, agentData => {
                return delay(50, buildMonthlySheetPDF(agentData, agentData.role));
            }).then(pdfDocsArray => {
                setDownloadState('Downloading...');

                // Convert all jsPDF documents to bytes
                const convertPDFsToBytes = async (pdfDocs) => {
                    const pdfBytesArray = [];
                    for (const pdfDoc of pdfDocs) {
                        const pdfBytes = pdfDoc.output('arraybuffer');
                        pdfBytesArray.push(pdfBytes);
                    }
                    return pdfBytesArray;
                };

                convertPDFsToBytes(pdfDocsArray).then(async (pdfBytesArray) => {
                    try {
                        // Load all PDFs into PDFDocument
                        const mergedPdf = await PDFDocument.create();
                        
                        for (const pdfBytes of pdfBytesArray) {
                            const pdf = await PDFDocument.load(pdfBytes);
                            const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
                            copiedPages.forEach((page) => {
                                mergedPdf.addPage(page);
                            });
                        }

                        // Save and download the merged PDF
                        const mergedPdfBytes = await mergedPdf.save();
                        const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
                        
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = `All_Agents_Report_${props.calStartDate.slice(0, 7)}.pdf`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        setDownloadState('Download Complete');
                    } catch (error) {
                        console.error('Error merging PDFs:', error);
                        setDownloadState('Error during merge');
                    }
                });
            }).catch(error => {
                console.error('Error generating PDFs:', error);
                setDownloadState('Error generating PDFs');
            });
        }).catch(error => {
            console.error('Error fetching agent data:', error);
            setDownloadState('Error fetching data');
        });
    };
    
    return (
        <div style={{width: '360px', height: 'auto', display: 'flex', flexDirection: 'column'}}>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'row'}}>
                <span style={{fontWeight: '500', fontSize: '20px', flexBasis: '99%'}}>Export Report</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border, width: '24px'}} size="16px">
                    <div onClick={() => {handleCancelFetch(); props.setIsOpen()}} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={() => {handleCancelFetch(); props.setIsOpen()}}>x</span></div>
                </IconButton>
            </div>
            <div style={{flexBasis: '90%', display: 'flex', flexDirection: 'column', marginTop: '20px'}}>
                <span style={{fontWeight: '500', fontSize:'16px'}}>Downloaded Rows: {downloadState === 0 ? loadedData.length:downloadState}</span>
                {/* <Button colors={props.colors} active={true} Style={{marginTop: '10px'}} onClick={() => downloadCSV(props.reportData, props.exportKeys, props.fileTitle, props.admin_report_info, props.startDate, props.endDate, false, props.selectedAgent.subagent_name)}>Download CSV</Button> */}
                {/* <Button colors={props.colors} active={true} Style={{marginTop: '10px'}} onClick={() => downloadALLCSV()}>Download All Agents CSV</Button> */}
                <Button colors={props.colors} active={true} Style={{marginTop: '10px'}} onClick={() => downloadPDF(props.reportData, props.exportKeys, props.fileTitle, props.admin_report_info, props.startDate, props.endDate, false, props.selectedAgent.subagent_name)}>Download PDF</Button>
                <Button colors={props.colors} active={true} Style={{marginTop: '10px'}} onClick={() => downloadAllPDF()}>Download All Users PDF</Button>
            </div>
        </div>
    )
}

export default Main
